import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'
import { useTranslation } from 'shared/hooks/useSafeTranslation'

import TwoRowErrorPage from 'shared/ErrorPages/TwoRowErrorPage'
import parseErrorMessage from 'shared/utils/parseErrorMessage'
import useStyles from 'shared/hooks/useStyle'

import style from './StyledErrorFallback.style'

const propTypes = {
    error: PropTypes.shape({ message: PropTypes.string }).isRequired,
    resetErrorBoundary: PropTypes.func.isRequired,
}

const StyledErrorFallback = ({
    error,
    resetErrorBoundary,
}) => {
    const { t } = useTranslation()
    const classes = useStyles(style)

    return (
        <TwoRowErrorPage
            message={parseErrorMessage(error)}
            iconPath="skycenter/not_working_robot.svg"
            iconAlt="error"
        >
            <Button
                data-testid="ok-button"
                css={classes.button}
                onClick={resetErrorBoundary}
            >
                {t('OK')}
            </Button>
        </TwoRowErrorPage>
    )
}

StyledErrorFallback.propTypes = propTypes

export default StyledErrorFallback
